import { styled } from "goober";
import { Dropdown } from "../Dropdown";
import { Icon } from "../Icon";
import { Text } from "../Text";
import { type ScopedRoute, useMonitoringScope } from "./useMonitoringScope";

const Container = styled("div")`
  margin-left: auto;
  display: flex;
  align-items: center;
  padding-right: 12px;
`;

const Trigger = styled("button")`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border: none;
  border-radius: 9999px;
  background: transparent;
  color: var(--text-primary);
  cursor: pointer;

  &:hover {
    background: var(--alpha4);
  }
`;

const OPTIONS = [
  { value: "personal", label: "Personal", icon: "circle-user-round" },
  { value: "spaces", label: "Spaces", icon: "hash" },
  { value: "both", label: "Personal + Spaces", icon: "building-2" },
] as const;

export function MonitoringScopeSelector({ route }: { route: ScopedRoute }) {
  const { scope, setScope } = useMonitoringScope(route);
  const current =
    OPTIONS.find((option) => option.value === scope) ?? OPTIONS[1];
  return (
    <Container>
      <Dropdown
        align="bottom"
        opener={
          <Trigger type="button">
            <Icon name={current.icon} size={16} color="var(--text-primary)" />
            <Text variant="text-small-md">{current.label}</Text>
            <Icon name="chevron-down" size={12} color="var(--text-secondary)" />
          </Trigger>
        }
        sections={[
          {
            items: OPTIONS.map((option) => ({
              type: "button" as const,
              key: option.value,
              left: (
                <Icon
                  name={option.icon}
                  size={16}
                  color="var(--text-primary)"
                />
              ),
              label: option.label,
              selected: option.value === scope,
              right:
                option.value === scope ? (
                  <Icon name="check" size={12} color="var(--text-secondary)" />
                ) : undefined,
              onClick: () => setScope(option.value),
            })),
          },
        ]}
      />
    </Container>
  );
}
